import styled from '@emotion/styled';
import { Space } from 'antd';
import PauseAutoReply from '../PauseAutoReply';
import { Star } from './Star';
import { Blacklist } from './Blacklist';
import { Forward } from './Forward';
import { Reception } from './Reception';

interface ToolsBarProps {
  conversation: Conversation.Conversation;
  pauseAutoReplyEnable: boolean;
  starEnable: boolean;
  blacklistEnable: boolean;
  forwardEnable: boolean;
}

export function ToolsBar(props: ToolsBarProps) {
  const { conversation, pauseAutoReplyEnable, starEnable, blacklistEnable, forwardEnable } = props;

  return (
    <BoxRight size={12}>
      {pauseAutoReplyEnable && <PauseAutoReply conversation={conversation} />}
      {starEnable && <Star conversation={conversation} />}
      {blacklistEnable && <Blacklist conversation={conversation} />}
      {forwardEnable && <Forward conversation={conversation} />}
      <Reception conversation={conversation} />
    </BoxRight>
  );
}

const BoxRight = styled(Space)`
  font-size: 20px;
  margin-left: auto;
  color: #464d5a;
  .anticon {
    cursor: pointer;
  }
`;
